import { FilterResult } from 'src/app/shared/components/odata-filter/models/filter-result';
import { Team } from './team';
import { ITeamQueryModel, TeamQueryModel } from './team-query.model';

export class TeamFilterResult implements FilterResult {
  public count: number;
  public values: TeamQueryModel[] = [];
  public nextLink: string;
  public parse(response: any) {
    let result = new TeamFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value.map((team: ITeamQueryModel) => TeamQueryModel.parse(team));
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
